import { useCallback } from "react";
import { Button, Row, Table } from "antd";
import { useGetTableColumns } from "./hooks/useGetTableColumns";
import { Footer } from "../common/Footer";
import { useFetchDataCount } from "../../../../../../../../../../lib/hooks/useDefaultFetchDataCount";
import { SimpleTablePagination } from "../../../../../../../../../../components/SimpleTablePagination";
import { useFetchData } from "../../../../../../../../../../lib/hooks/useDefaultFetchData";
import { DistributionModal } from "./DistributionModal";
import DistributionService from "../../../../../../../../../../services/accounts/impounds/distributions";
import { TRequest } from "../common/types";
import { IImpDistributionGet } from "../../../../../../../../../../types/Distribuions";
import { usePermissions } from "../../../../../../../../../../lib/hooks/usePermissions";
import { IImpoundSingle } from "../../../../../../../../../../types/Impounds";

type TDistributions = {
  impoundAccount: IImpoundSingle | null;
  payeesNumber: {
    primaryBuyerNumber: number;
    primarySellerNumber: number;
  };
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setParentId: React.Dispatch<React.SetStateAction<string | null>>;
  isDistributionModalOpen: boolean;
  setIsDistributionModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const Distributions = ({
  impoundAccount,
  payeesNumber,
  setIsOpen,
  setParentId,
  isDistributionModalOpen,
  setIsDistributionModalOpen
}: TDistributions) => {
  const {
    isLoading: isCountLoading,
    total,
    request,
    onPageChange,
    fetchCount
  } = useFetchDataCount<{ impoundId: string | null }>(DistributionService, {
    impoundId: impoundAccount?.id || null
  });

  const { hasAccessByController } = usePermissions("ImpoundDistributions");

  const { isLoading, data, fetchData } = useFetchData<TRequest, IImpDistributionGet>(
    DistributionService,
    request,
    ".payments-from-table .ant-table-content"
  );

  const reloadData = useCallback(() => {
    fetchCount();
    fetchData();
  }, [fetchCount, fetchData]);

  const { columns } = useGetTableColumns({
    setIsModalOpen: setIsDistributionModalOpen,
    reloadData,
    parentId: impoundAccount?.id || null
  });

  const openModal = useCallback(() => setIsDistributionModalOpen(true), [setIsDistributionModalOpen]);

  return (
    <Row className="d-block w-100 activities__container">
      {hasAccessByController("Add") && (
        <Button className="mt-6 ml-6" shape="round" onClick={openModal}>
          Pay From Impound
        </Button>
      )}
      <Row className="d-block mt-4 px-6 w-100 sidebar-table small-table">
        <Table
          className="w-100 clickable-rows-table payments-from-table"
          dataSource={data}
          columns={columns}
          pagination={false}
          rowKey="id"
          loading={isLoading}
        />
        {total > 20 && (
          <SimpleTablePagination
            isLoading={isCountLoading}
            total={total}
            pageNumber={request.pageNumber}
            onPageChange={onPageChange}
            pageSize={request.pageSize}
          />
        )}
      </Row>
      <Footer setId={setParentId} setIsOpen={setIsOpen} />
      <DistributionModal
        impoundAccount={impoundAccount}
        isOpen={isDistributionModalOpen}
        reloadData={reloadData}
        setIsOpen={setIsDistributionModalOpen}
        parentId={impoundAccount?.id || null}
        payeesNumber={payeesNumber}
      />
    </Row>
  );
};
